import './Motivation.scss'

const Motivation = ({ icon, description }) => {
  return (
    <div className="motivation">
      <div className="motivation-title">{icon}</div>
      <div className="motivation-description">{description}</div>

      <div className="motivation-border-right"></div>
      <div className="motivation-border-bottom"></div>
    </div>
  )
}

export default Motivation;